import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import ContentHeader from "@/components/ContentHeader";
import InfinityScrollList from "@/components/InfinityScrollList";
import Loading from "@/components/Loading";
import { useCopyrights, usePagination } from "@/hooks";
import styles from "@/styles/List.module.scss";
import classnames from "classnames";
import { cloneElement, createElement, memo, useEffect } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function List(_ref) {
  var _items$data, _items$data2;
  let {
    header,
    itemComponent,
    // itemをレンダーするコンポーネント
    limit,
    maxLength,
    loadMore,
    loading,
    // useQueryの戻り値
    error,
    // useQueryの戻り値
    fetchMore,
    // useQueryの戻り値
    variables,
    // useQueryの戻り値
    items,
    noContent,
    viewTypeClassName // このpropsなくしたい
  } = _ref;
  if (error) {
    // TODO: error view
  }
  const {
    setCopyrights
  } = useCopyrights();
  const {
    enableLoadMore,
    fetchMoreCallback
  } = usePagination({
    limit: limit !== null && limit !== void 0 ? limit : variables === null || variables === void 0 ? void 0 : variables.limit,
    maxLength,
    loadMore,
    fetchMore,
    items
  });
  const dataLength = (items === null || items === void 0 || (_items$data = items.data) === null || _items$data === void 0 ? void 0 : _items$data.length) || 0;
  useEffect(() => {
    if (items && items.data.length > 0) {
      const copyrights = items.data.map(item => item.copyright);
      setCopyrights(copyrights);
    }
  }, [dataLength]);
  if (!loading && (items === null || items === void 0 || (_items$data2 = items.data) === null || _items$data2 === void 0 ? void 0 : _items$data2.length) === 0) {
    if (noContent) {
      return /*#__PURE__*/_jsx("div", {
        className: styles.container,
        children: /*#__PURE__*/cloneElement(noContent)
      });
    } else {
      return null;
    }
  }
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(styles.container, {
      [styles.grid]: viewTypeClassName === "grid",
      [styles.list]: viewTypeClassName === "list",
      [styles.pickuplist]: viewTypeClassName === "pickuplist",
      [styles.channelsList]: viewTypeClassName === "channelsList"
    }),
    children: [header && /*#__PURE__*/_jsx(ContentHeader, _objectSpread({
      viewTypeClassName: viewTypeClassName
    }, header)), loading && dataLength === 0 && /*#__PURE__*/_jsx("div", {
      className: styles.loading,
      children: /*#__PURE__*/_jsx(Loading, {})
    }), /*#__PURE__*/_jsx("div", {
      className: styles.list,
      children: /*#__PURE__*/_jsx(InfinityScrollList, {
        loadMore: enableLoadMore,
        fetchMore: fetchMoreCallback,
        children: items && items.data.map((item, i) => /*#__PURE__*/_jsx(ListItem, {
          itemComponent: itemComponent,
          item: item
        }, `list-${i}`))
      })
    })]
  });
}
const ListItem = /*#__PURE__*/memo(_ref2 => {
  let {
    itemComponent,
    item
  } = _ref2;
  return /*#__PURE__*/_jsx("div", {
    className: styles.listItem,
    children: /*#__PURE__*/createElement(itemComponent, {
      item
    })
  });
});